import { observable, configure, action, computed, runInAction } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class TrophyStore extends LocalModel {
    constructor() {
        super('trophy', {
            namePlural: 'trophies',
            sort: 'sort',
            limit: 100,
            api: {
                search: {
                    url: '/api/trophies/',
                    params: {
                        limit: 50,
                        sort: 'sort',
                    },
                },
                load: {
                    url: '/api/trophies/',
                    params: {},
                },
                save: {
                    url: '/api/trophies/',
                    params: {},
                },
                delete: {
                    url: '/api/trophies/',
                    params: {},
                },
            },
        });
    }

    @observable newTrophy = {};

    @observable trophy = {};

    @observable trophies = [];

    @observable predefinedTrophies = [];

    @observable predefinedCategories = [];

    @observable predefinedGrouped = {};

    async loadByUser(userId, forceLoad = false) {
        const response = await util.fetchApi(`/api/trophies/?user=${userId}`);
        if (response && response.status === 200 && response.data) {
            runInAction(() => {
                this.trophies = response.data;
            });
        }
        return response;
    }

    async generateShareImage(trophyId) {
        const response = await util.fetchApi(`/api/trophies/${trophyId}/screenshot`, { publish: true }, 'POST');
        if (response && response.status === 200 && response.data) {
            // Update the trophy in the local list with the new shareImage
            runInAction(() => {
                const index = this.trophies.findIndex(t => t.id === trophyId);
                if (index !== -1) {
                    this.trophies[index] = { ...this.trophies[index], shareImage: response.data.shareImage };
                }
            });
        }
        return response;
    }

    async loadPredefinedTrophies() {
        const response = await util.fetchApi('/api/trophies/predefined');
        if (response && response.status === 200) {
            runInAction(() => {
                this.predefinedTrophies = response.data || [];
                this.predefinedCategories = response.categories || [];
                this.predefinedGrouped = response.grouped || {};
            });
        }
        return response;
    }

    async addAdminTrophy(trophyData) {
        const response = await util.fetchApi('/api/trophies/admin', { method: 'POST' }, trophyData);
        return response;
    }

    async saveTrophyDefinition(definitionData) {
        const response = await util.fetchApi('/api/trophies/definition', { method: 'POST' }, definitionData);
        if (response && response.status === 201) {
            // Reload predefined trophies to include the new one
            await this.loadPredefinedTrophies();
        }
        return response;
    }

    async updateTrophyDefinition(definitionId, definitionData) {
        const response = await util.fetchApi(`/api/trophies/definition/${definitionId}`, { method: 'PATCH' }, definitionData);
        if (response && response.status === 200) {
            // Reload predefined trophies to reflect changes
            await this.loadPredefinedTrophies();
        }
        return response;
    }

    async deleteTrophyDefinition(definitionId) {
        const response = await util.fetchApi(`/api/trophies/definition/${definitionId}`, { method: 'DELETE' });
        if (response && response.status === 200) {
            // Reload predefined trophies to reflect deletion
            await this.loadPredefinedTrophies();
        }
        return response;
    }
}

const store = new TrophyStore();
export default store;
